/* LumaSky — JS propio (vanilla, sin librerias) */

function lskInitReveal() {
  var els = document.querySelectorAll('.lsk-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('lsk-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lsk-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function lskInitGaleriaProducto() {
  var galeria = document.querySelector('[data-lsk-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-lsk-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-lsk-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.src = src;
      minis.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

function lskInitVariantes() {
  var form = document.querySelector('[data-lsk-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-lsk-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = form.querySelector('input[name="id"]');
  var boton = form.querySelector('[data-lsk-boton-comprar]');
  var precioActual = document.querySelector('[data-lsk-precio-actual]');
  var precioAnterior = document.querySelector('[data-lsk-precio-anterior]');
  var imagenPrincipal = document.querySelector('[data-lsk-galeria-principal]');
  var opciones = document.querySelectorAll('[data-lsk-opcion]');
  if (!opciones.length) return;

  function estadoSeleccion() {
    var seleccion = {};
    document.querySelectorAll('[data-lsk-grupo]').forEach(function (grupo) {
      var activa = grupo.querySelector('.is-activa');
      if (activa) seleccion[grupo.getAttribute('data-lsk-grupo')] = activa.getAttribute('data-valor');
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = estadoSeleccion();
    return variantes.find(function (v) {
      return v.opciones.every(function (op, i) { return seleccion[v.nombres[i]] === op; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioActual) precioActual.textContent = variante.precio;
    if (precioAnterior) {
      if (variante.precioAnterior) {
        precioAnterior.textContent = variante.precioAnterior;
        precioAnterior.hidden = false;
      } else {
        precioAnterior.hidden = true;
      }
    }
    if (boton) {
      boton.disabled = !variante.disponible;
      boton.textContent = variante.disponible ? boton.getAttribute('data-texto-disponible') : boton.getAttribute('data-texto-agotado');
    }
    if (imagenPrincipal && variante.imagen) {
      imagenPrincipal.src = variante.imagen;
    }
  }

  opciones.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grupo = btn.closest('[data-lsk-grupo]');
      grupo.querySelectorAll('[data-lsk-opcion]').forEach(function (b) { b.classList.remove('is-activa'); });
      btn.classList.add('is-activa');
      actualizar();
    });
  });

  actualizar();
}

function lskInitCountdown() {
  var bar = document.querySelector('[data-lsk-countdown]');
  if (!bar) return;
  var endStr = bar.getAttribute('data-end');
  var end = new Date(endStr).getTime();
  if (isNaN(end)) return;

  var elD = bar.querySelector('[data-lsk-cd-d]');
  var elH = bar.querySelector('[data-lsk-cd-h]');
  var elM = bar.querySelector('[data-lsk-cd-m]');
  var elS = bar.querySelector('[data-lsk-cd-s]');

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    var diff = end - now;
    if (diff <= 0) {
      bar.style.display = 'none';
      clearInterval(timer);
      return;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (elD) elD.textContent = pad(d);
    if (elH) elH.textContent = pad(h);
    if (elM) elM.textContent = pad(m);
    if (elS) elS.textContent = pad(s);
  }

  tick();
  var timer = setInterval(tick, 1000);
}

document.addEventListener('DOMContentLoaded', function () {
  lskInitReveal();
  lskInitGaleriaProducto();
  lskInitVariantes();
  lskInitCountdown();
});
